<template>
	<b-modal
		:hide-footer="true"
		:hide-header-close="true"
		:no-close-on-backdrop="true"
		:no-close-on-esc="true"
		:title="$t('Cadastrar Logradouro')"
		centered
		id="add-logradouro"
		no-fade
	>
		<template v-slot:default>
			<form @submit.prevent="addLogradouro" ref="addLogradouro">
				<div class="row toUpperCase">
					<form-input
						v-model="logradouro.cep_logradouro"
						grid="12"
						label="CEP"
						:required="true"
						v-mask="'#####-###'"
						placeholder="00000-000"
					/>

					<form-select
						ref="select"
						grid="12"
						:label="$t('Bairro/Localidade')"
						:itens="options"
						v-model="logradouro.localidade_id"
						@search="searchLocalidade"
						:loading="loadingLocalidade"
						:required="true"
					/>

					<form-input
						v-model="logradouro.tipo_logradouro"
						grid="12"
						label="Tipo (rua, avenida,igarapé etc.)"
						:required="true"
					/>

					<form-input
						v-model="logradouro.titulo_logradouro"
						grid="12"
						label="Título (general, santa, pintor etc.)"
					/>

					<form-input
						v-model="logradouro.nome_logradouro"
						grid="12"
						label="Nome do Logradouro"
						:required="true"
					/>
				</div>

				<div class="float-right mt-3">
					<router-link class="btn btn-danger" to="/dashboard/enderecos/logradouros">
						<i class="mdi mdi-close" />
						{{ $t("Cancelar") }}
					</router-link>
					<button class="btn btn-success btn-submit" data-style="zoom-in" type="submit">
						<i class="mdi mdi-content-save" />
						{{ $t("Salvar") }}
					</button>
				</div>
			</form>
		</template>
	</b-modal>
</template>

<script>
export default {
	name: "Add",
	mounted() {
		this.$bvModal.show("add-logradouro");
	},
	data() {
		return {
			loading: false,
			logradouro: {},
			options: [],
			loadingLocalidade: false,
		};
	},
	methods: {
		// Add role
		addLogradouro() {
			let ladda = Ladda.create(document.querySelector(".btn-submit"));
			ladda.start();
			// Send request
			this.logradouro.origem_logradouro = 1;
			axios
				.post("api/dashboard/enderecos/logradouros", this.logradouro)
				.then((response) => {
					ladda.stop();
					this.$snack.success({
						button: false,
						text: response.data.data.message,
					});
					this.$router.push("/dashboard/enderecos/logradouros");
					this.$parent.getLogradouros();
				});
		},

		searchLocalidade: function searchLocalidade(search) {
			if (search != "") {
				clearTimeout(searchLocalidade.timeout);
				searchLocalidade.timeout = setTimeout(() => {
					this.loadingLocalidade = true;
					this.$refs.select.openOptions(false);
					axios
						.get(`api/dashboard/enderecos/pesquisar_bairro?q=${escape(search)}`)
						.then((response) => {
							this.options = response.data;
							this.$refs.select.openOptions(false);
						})
						.finally(() => {
							this.$refs.select.closeOptions(false);
							setTimeout(() => {
								this.loadingLocalidade = false;
								this.$refs.select.openOptions(true);
							}, 3000);
						});
				}, 1000);
			}
		},
	},
};
</script>

<style>
.toUpperCase input[type="text"] {
	text-transform: uppercase;
}
</style>

